import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { useStyles } from './style';
import Link  from '@material-ui/core/Link';
import "../../App.css"
import { checkDomainIsCaptis } from "../../utils/Index";

function Footer() {
  const classes = useStyles();
  const currentYear = new Date().getFullYear();
  const isCaptis = checkDomainIsCaptis();

  return (
    <div className={classes.footRoot}>
      <AppBar position="static" >
        <Toolbar className="footToolBar" variant="dense">
          <div className="copy-right">
          © {currentYear} <Link href={isCaptis ? "https://captispay.com/" : "https://patronpay.us/"} target="_blank" underline="hover" className="white"> { isCaptis ? "CaptisPay" : "PatronPay" } </Link>
          </div>
          <div style={{display: 'flex', justifyContent: "space-between", width: "12em"}}>
          <Link href={isCaptis ? "https://captispay.com/" : "https://patronpay.us/"} target="_blank" underline="hover" className="white">{ isCaptis ? "CaptisPay" : "PatronPay" }</Link>
          <Link href={isCaptis ? "https://captispay.com/about/" : "https://patronpay.us/about/"} target="_blank" underline="hover" className="white">About Us</Link>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default Footer;